export default [
  { label: 'Forever',  value: 'forever' },
  { label: 'Once', value: 'once' },
  { label: 'Multiple Months',  value: 'repeating' }
];
